/* eslint-disable @typescript-eslint/no-this-alias,@typescript-eslint/no-unused-expressions */
import { Component } from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import PropTypes from "prop-types";

import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Button,
  OverlayTrigger,
  Tooltip,
  InputGroup,
  Accordion,
  Card,
  Modal,
} from "react-bootstrap";
import queryString from "query-string";

import Billing from "./Billing/BillingInfo.js";
import LoadingWrapper from "../widgets/LoadingWrapper";
import SavedCheck from "../widgets/SavedCheck";
import { QuestionCircleFill } from "react-bootstrap-icons";
import { Link } from "react-router-dom";

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monthlyRemasterCount: 0,
      buyCreditsModal: false,
    };
  }

  async componentDidMount() {
    this.props.getSubscription();
    this.props.getInvoices();

    const couponSuggestion = this.props.location
      ? queryString.parse(this.props.location.search).couponSuggestion
      : "";
    if (couponSuggestion) {
      this.props.checkPromoCode(couponSuggestion);
    }
    const saveThis = this;
    !(function () {
      if (window.barecancel && window.barecancel.created)
        window.console && console.error && console.error("Barecancel snippet included twice.");
      else {
        window.barecancel = { created: !0 };
        var a = document.createElement("script");
        ((a.src = "https://baremetrics-barecancel.baremetrics.com/js/application.js"),
          (a.async = !0));
        var b = document.getElementsByTagName("script")[0];
        (b.parentNode.insertBefore(a, b),
          (window.barecancel.params = {
            access_token_id: "505e2703-648c-43b3-8491-e02c49d26203", // Your Cancellation API public key
            customer_oid: saveThis.props.user.stripe_customer_id, // The provider id of this customer. For example, the Stripe Customer ID
            callback_send: function (data) {
              saveThis.props.cancelPlan();
            },
            callback_error: function (error) {
              // You can also catch any errors that happen when sending the cancellation event to Baremetrics.
              // For example, if Baremetrics returns that the customer does not have an active subscription.
              console.error(error);
            },
          }));
      }
    })();
  }

  async componentDidUpdate(prevProps) {
    if (this.props.subscription !== prevProps.subscription) {
      this.handleMonthlyRemasterCount();
    }
  }

  handleMonthlyRemasterCount() {
    let count = 0;
    if (
      this.props.subscription.plan === "starter" ||
      this.props.subscription.plan === "starter-annual"
    ) {
      count = 1;
    } else if (
      this.props.subscription.plan === "pro" ||
      this.props.subscription.plan === "pro-annual"
    ) {
      count = 5;
    } else if (
      this.props.subscription.plan === "powerhouse" ||
      this.props.subscription.plan === "powerhouse-annual"
    ) {
      count = 10;
    } else {
      count = 0;
    }
    return this.setState({ monthlyRemasterCount: count });
  }

  render() {
    const totalRemasters =
      this.props.user.monthly_remasters_remaining + this.props.user.alacarte_remasters_remaining;

    return (
      <>
        {this.props.user.feedLimit === 0 ? (
          <Billing />
        ) : (
          <div className="account-background">
            <LoadingWrapper loadingKey="auth0-user">
              <Container>
                <Row className="subhead mb-3 justify-content-center text-center">
                  Your Account and Billing Info
                </Row>

                <Row>
                  <Col className="centering-div-container flex-column ">
                    <Formik
                      enableReinitialize
                      initialValues={{
                        name: this.props.user.last_known_name,
                        email: this.props.user.last_known_email,
                        reply_to: this.props.user.reply_to,
                        business: this.props.user.business,
                        copyright: this.props.user.copyright,
                        affiliate_link: this.props.user.affiliate_link,
                        affiliate_link_options: this.props.user.affiliate_link_options || {
                          feed_descriptions: false,
                          episode_descriptions: false,
                          embeddable_players: false,
                          subscribe_pages: false,
                        },
                        password: "",
                      }}
                      validate={(values) => {
                        const errors = {};
                        const regex = /^\S+@\S+\.\S+$/;

                        if (!values.email) {
                          errors.email = "Email is required";
                        } else if (!regex.test(values.email)) {
                          errors.email = "invalid Email";
                        }

                        if (values.reply_to && !regex.test(values.reply_to)) {
                          errors.reply_to = "invalid Email";
                        }
                        return errors;
                      }}
                      onSubmit={(values) => {
                        this.props.updateProfile({
                          name:
                            values.name !== this.props.user.last_known_name ? values.name : null,
                          email:
                            values.email !== this.props.user.last_known_email ? values.email : null,
                          replyTo: values.reply_to === "" ? null : values.reply_to,
                          business: values.business,
                          copyright: values.copyright,
                          password: values.password,
                          affiliateLink: values.affiliate_link,
                          affiliateLinkOptions: values.affiliate_link_options,
                          silent: true,
                        });
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        isSubmitting,
                      }) => (
                        <Form
                          noValidate
                          id="updateProfileForm"
                          onSubmit={(e) => handleSubmit(e)}
                          className="account-form-container mx-auto"
                        >
                          <Form.Row>
                            <FormGroup className="align-items-center w-100">
                              <Col xs="auto">
                                <Form.Label className="d-flex">
                                  <span>Full Name: &nbsp;</span>
                                  <OverlayTrigger
                                    key="top"
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-top">
                                        <p>Not visible to your listeners</p>
                                      </Tooltip>
                                    }
                                  >
                                    <span className="d-flex align-items-center">
                                      <QuestionCircleFill />
                                    </span>
                                  </OverlayTrigger>
                                </Form.Label>
                              </Col>
                              <Col xs="auto">
                                <Form.Control
                                  inline
                                  type="text"
                                  name="name"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.name}
                                />
                              </Col>
                            </FormGroup>
                          </Form.Row>

                          <Form.Row>
                            <FormGroup className="align-items-center w-100">
                              <Col xs="auto">
                                <Form.Label className="d-flex">
                                  <span>Email: &nbsp;</span>
                                  <OverlayTrigger
                                    key="top"
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-top">
                                        <p>
                                          Visible in feeds as the owner. Used by some platforms to
                                          verify ownership
                                        </p>
                                      </Tooltip>
                                    }
                                  >
                                    <span className="d-flex align-items-center">
                                      <QuestionCircleFill />
                                    </span>
                                  </OverlayTrigger>
                                </Form.Label>
                              </Col>
                              <Col xs="auto">
                                <Form.Control
                                  inline
                                  type="text"
                                  name="email"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.email}
                                  isInvalid={!!errors.email}
                                />
                                {errors.email && (
                                  <Form.Control.Feedback type="invalid">
                                    {errors.email}
                                  </Form.Control.Feedback>
                                )}
                              </Col>
                            </FormGroup>
                          </Form.Row>

                          <Form.Row>
                            <FormGroup className="align-items-center w-100">
                              <Col xs="auto">
                                <Form.Label className="d-flex">
                                  <span>Reply-To: &nbsp;</span>
                                  <OverlayTrigger
                                    key="top"
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-top">
                                        <p>
                                          Listeners can reply to the subscription email that we send
                                          on your behalf. Replies will go to your account address
                                          unless you check this box and specify another.
                                        </p>
                                      </Tooltip>
                                    }
                                  >
                                    <span className="d-flex align-items-center">
                                      <QuestionCircleFill />
                                    </span>
                                  </OverlayTrigger>
                                </Form.Label>
                              </Col>
                              <Col xs="auto">
                                <Form.Control
                                  inline
                                  type="text"
                                  name="reply_to"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.reply_to}
                                  isInvalid={!!errors.reply_to}
                                />
                                {errors.reply_to && (
                                  <Form.Control.Feedback type="invalid">
                                    {errors.reply_to}
                                  </Form.Control.Feedback>
                                )}
                              </Col>
                            </FormGroup>
                          </Form.Row>

                          <Form.Row>
                            <FormGroup className="align-items-center w-100">
                              <Col xs="auto">
                                <Form.Label className="d-flex">
                                  <span>Business Name: &nbsp;</span>
                                  <OverlayTrigger
                                    key="top"
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-top">
                                        <p>Visible in feeds as the copyright holder</p>
                                      </Tooltip>
                                    }
                                  >
                                    <span className="d-flex align-items-center">
                                      <QuestionCircleFill />
                                    </span>
                                  </OverlayTrigger>
                                </Form.Label>
                              </Col>
                              <Col xs="auto">
                                <Form.Control
                                  inline
                                  type="text"
                                  name="business"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.business}
                                />
                              </Col>
                            </FormGroup>
                          </Form.Row>

                          {/* TODO: here */}
                          <Form.Row>
                            <FormGroup className="align-items-center w-100">
                              <Col xs="auto">
                                <Form.Label className="d-flex">
                                  <span>Password: &nbsp;</span>
                                  <OverlayTrigger
                                    key="top"
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-top">
                                        <p>Must contain:</p>
                                        <div>
                                          &#8226; 8+ characters <br />
                                          &#8226; An upper-case letter <br />
                                          &#8226; lower-case letter <br />
                                          &#8226; and a number <br />
                                        </div>
                                      </Tooltip>
                                    }
                                  >
                                    <span className="d-flex align-items-center">
                                      <QuestionCircleFill />
                                    </span>
                                  </OverlayTrigger>
                                </Form.Label>
                              </Col>
                              <Col xs="auto">
                                <Form.Control
                                  inline
                                  type="password"
                                  name="password"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.password}
                                />
                              </Col>
                            </FormGroup>
                          </Form.Row>
                          <Form.Row className="px-2 pt-1 mb-3">
                            <Col>
                              <Accordion>
                                <Card>
                                  <Card.Header className="p-0" style={{ maxHeight: "38px" }}>
                                    <Accordion.Toggle
                                      as={Button}
                                      variant="link"
                                      eventKey="advanced"
                                      style={{
                                        paddingLeft: "17px",
                                        boxShadow: "unset",
                                      }}
                                    >
                                      <span>Affiliate Link Settings</span>
                                    </Accordion.Toggle>
                                  </Card.Header>
                                  <Accordion.Collapse eventKey="advanced">
                                    <Card.Body>
                                      <Form.Row>
                                        <Form.Group className="align-items-center w-100">
                                          <Col xs="auto">
                                            <Form.Label className="d-flex">
                                              <span>
                                                Show your Hello Audio Affiliate Link to Listeners
                                                &nbsp;
                                              </span>
                                              <OverlayTrigger
                                                key="top"
                                                placement="top"
                                                overlay={
                                                  <Tooltip id="tooltip-top">
                                                    <p>
                                                      Every place you check, a link to Hello Audio
                                                      will be inserted with your affiliate code,
                                                      giving you a chance to earn money if somebody
                                                      in your audience signs up for Hello Audio.
                                                    </p>
                                                  </Tooltip>
                                                }
                                              >
                                                <span className="d-flex align-items-center">
                                                  <QuestionCircleFill />
                                                </span>
                                              </OverlayTrigger>
                                            </Form.Label>
                                          </Col>
                                          <Col xs="auto">
                                            <Form.Check>
                                              <Form.Check.Input
                                                onChange={(event) =>
                                                  setFieldValue("affiliate_link_options", {
                                                    ...values.affiliate_link_options,
                                                    episode_descriptions: !!event.target.checked,
                                                  })
                                                }
                                                onBlur={handleBlur}
                                                checked={
                                                  values.affiliate_link_options.episode_descriptions
                                                }
                                              />
                                              <Form.Check.Label>
                                                In episode show notes
                                              </Form.Check.Label>
                                            </Form.Check>
                                          </Col>
                                          <Col xs="auto">
                                            <Form.Check>
                                              <Form.Check.Input
                                                onChange={(event) =>
                                                  setFieldValue("affiliate_link_options", {
                                                    ...values.affiliate_link_options,
                                                    embeddable_players: !!event.target.checked,
                                                  })
                                                }
                                                onBlur={handleBlur}
                                                checked={
                                                  values.affiliate_link_options.embeddable_players
                                                }
                                              />
                                              <Form.Check.Label>
                                                In embeddable players
                                              </Form.Check.Label>
                                            </Form.Check>
                                          </Col>
                                          <Col xs="auto">
                                            <Form.Check>
                                              <Form.Check.Input
                                                onChange={(event) =>
                                                  setFieldValue("affiliate_link_options", {
                                                    ...values.affiliate_link_options,
                                                    subscribe_pages: !!event.target.checked,
                                                  })
                                                }
                                                onBlur={handleBlur}
                                                checked={
                                                  values.affiliate_link_options.subscribe_pages
                                                }
                                              />
                                              <Form.Check.Label>
                                                At the bottom of the subscribe page that listeners
                                                are emailed
                                              </Form.Check.Label>
                                            </Form.Check>
                                          </Col>
                                        </Form.Group>
                                      </Form.Row>

                                      <Form.Row>
                                        <Form.Group className="align-items-center w-100">
                                          <Col xs="auto">
                                            <Form.Label className="d-flex">
                                              <span>Affiliate Link Code: &nbsp;</span>
                                              <OverlayTrigger
                                                key="top"
                                                placement="top"
                                                overlay={
                                                  <Tooltip id="tooltip-top">
                                                    <p>
                                                      The unique code that appears after ?fpr= in
                                                      your Affiliates dashboard. To get started as a
                                                      Hello Audio Affiliate and earn money when you
                                                      refer people to us, visit the Affiliates page
                                                      and sign up with FirstPromoter.
                                                    </p>
                                                  </Tooltip>
                                                }
                                              >
                                                <span className="d-flex align-items-center">
                                                  <QuestionCircleFill />
                                                </span>
                                              </OverlayTrigger>
                                            </Form.Label>
                                          </Col>
                                          <Col xs="auto">
                                            <InputGroup>
                                              <InputGroup.Prepend>
                                                <InputGroup.Text>?fpr=</InputGroup.Text>
                                              </InputGroup.Prepend>
                                              <Form.Control
                                                inline
                                                type="text"
                                                name="affiliate_link"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.affiliate_link}
                                              />

                                              <InputGroup.Append>
                                                <LoadingWrapper loadingKey="load-affiliate-code-from-first-promoter">
                                                  <Button
                                                    onClick={() =>
                                                      this.props.loadAffiliateCodeFromFirstPromoter()
                                                    }
                                                  >
                                                    Load From FirstPromoter
                                                  </Button>
                                                </LoadingWrapper>
                                              </InputGroup.Append>
                                            </InputGroup>
                                          </Col>
                                          <Col xs="auto" className="pt-1">
                                            <a
                                              href="https://app.helloaudio.fm/affiliate"
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              Manage Your Affiliate Account
                                            </a>
                                          </Col>
                                        </Form.Group>
                                      </Form.Row>
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              </Accordion>
                            </Col>
                          </Form.Row>
                          <Form.Row className="px-2 py-1 mb-2">
                            <Col>
                              <Accordion>
                                <Card>
                                  <Card.Header className="p-0" style={{ maxHeight: "38px" }}>
                                    <Accordion.Toggle
                                      as={Button}
                                      variant="link"
                                      eventKey="advanced"
                                      style={{
                                        paddingLeft: "17px",
                                        boxShadow: "unset",
                                      }}
                                    >
                                      <span>Remastered Audio, Powered by Dolby.io</span>
                                    </Accordion.Toggle>
                                  </Card.Header>
                                  <Accordion.Collapse eventKey="advanced">
                                    <Card.Body>
                                      <Form.Row className="mb-3">
                                        <span>
                                          You have{" "}
                                          {totalRemasters === 1 ? (
                                            <span>
                                              <strong>{totalRemasters}</strong> remaster
                                            </span>
                                          ) : (
                                            <span>
                                              <strong>{totalRemasters}</strong> remasters
                                            </span>
                                          )}{" "}
                                          available this month.&nbsp;
                                        </span>
                                        <span>
                                          On the 1st of next month, you will have{" "}
                                          <strong>
                                            {this.state.monthlyRemasterCount +
                                              this.props.user.alacarte_remasters_remaining}
                                          </strong>{" "}
                                          remasters available.
                                        </span>
                                      </Form.Row>
                                      <Form.Row className="mb-3">
                                        <span>Your plan comes with</span>
                                        <OverlayTrigger
                                          key="top"
                                          placement="top"
                                          overlay={
                                            <Tooltip id="tooltip-top">
                                              <div>
                                                Starter - 1 <br />
                                                Pro - 5 <br />
                                                Powerhouse - 10 <br />
                                              </div>
                                            </Tooltip>
                                          }
                                        >
                                          <span className="d-flex align-items-center px-1">
                                            <strong>{this.state.monthlyRemasterCount}</strong>
                                          </span>
                                        </OverlayTrigger>
                                        <span>
                                          free remasters each month. These don&apos;t rollover.
                                        </span>
                                        {this.props.user.alacarte_remasters_remaining !== 0 && (
                                          <span>
                                            You have an additional{" "}
                                            {this.props.user.alacarte_remasters_remaining === 1 ? (
                                              <span>
                                                <strong>
                                                  {this.props.user.alacarte_remasters_remaining}
                                                </strong>{" "}
                                                remaster
                                              </span>
                                            ) : (
                                              <span>
                                                <strong>
                                                  {this.props.user.alacarte_remasters_remaining}
                                                </strong>{" "}
                                                remasters
                                              </span>
                                            )}{" "}
                                            which never expire.
                                          </span>
                                        )}
                                      </Form.Row>
                                      <Form.Row
                                        className={
                                          this.props.subscription.plan === "trial" && "d-none"
                                        }
                                      >
                                        <span>
                                          To purchase <strong>5</strong> additional remasters for{" "}
                                          <strong>$15</strong>,{" "}
                                          <Button
                                            variant="link"
                                            className="px-0"
                                            style={{ paddingBottom: "10px" }}
                                            onClick={() =>
                                              this.setState({
                                                buyCreditsModal: true,
                                              })
                                            }
                                          >
                                            click here
                                          </Button>
                                          . These additional remasters do rollover.
                                        </span>
                                      </Form.Row>

                                      <Modal
                                        className=""
                                        show={this.state.buyCreditsModal}
                                        onHide={() =>
                                          this.setState({
                                            buyCreditsModal: false,
                                          })
                                        }
                                      >
                                        <Modal.Header closeButton className="text-center">
                                          <Modal.Title
                                            className="billing-modal-title w-100"
                                            style={{ fontSize: "22px" }}
                                          >
                                            Purchase Remastering Credits
                                          </Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                          {this.props.subscription.plan === "trial" ? (
                                            <p className="text-center">
                                              To remaster more content, sign up for a paid plan{" "}
                                              <Link to="/subscription">here</Link>.
                                            </p>
                                          ) : (
                                            <p className="text-center">
                                              You{" "}
                                              {totalRemasters === 0 ? (
                                                "are out of remastering credits"
                                              ) : totalRemasters === 1 ? (
                                                <span>have {totalRemasters} remaster credit</span>
                                              ) : (
                                                <span>
                                                  have {totalRemasters} remastering credits
                                                </span>
                                              )}{" "}
                                              this month. Would you like to purchase 5 for $15?
                                              These never expire. You card will be charged
                                              immediately.
                                            </p>
                                          )}
                                        </Modal.Body>

                                        {this.props.subscription.plan !== "trial" && (
                                          <>
                                            <Modal.Footer className="justify-content-around">
                                              <Button
                                                className="float-left"
                                                variant="danger"
                                                onClick={() =>
                                                  this.setState({
                                                    buyCreditsModal: false,
                                                  })
                                                }
                                              >
                                                No
                                              </Button>
                                              <LoadingWrapper loadingKey="buy-alacarte-remasters">
                                                <Button
                                                  onClick={() =>
                                                    this.props.buyAlacarteRemasters({
                                                      callback: () =>
                                                        this.setState({
                                                          buyCreditsModal: false,
                                                        }),
                                                    })
                                                  }
                                                >
                                                  Yes
                                                </Button>
                                              </LoadingWrapper>
                                            </Modal.Footer>
                                          </>
                                        )}
                                      </Modal>
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              </Accordion>
                            </Col>
                          </Form.Row>
                        </Form>
                      )}
                    </Formik>

                    {!this.props.subscription.plan ||
                    this.props.subscription.plan === "starter" ||
                    this.props.subscription.plan === "pro" ||
                    this.props.subscription.plan === "powerhouse" ||
                    this.props.subscription.plan === "starter-annual" ||
                    this.props.subscription.plan === "pro-annual" ||
                    this.props.subscription.plan === "powerhouse-annual" ||
                    this.props.subscription.plan.match(/founder/) ||
                    this.props.subscription.plan === "trial" ? (
                      <>
                        <Row className="w-75 mx-auto justify-content-start  ">
                          <OverlayTrigger
                            key="top"
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-top">
                                <p>
                                  View invoices, update payment method, change/cancel your plan.
                                </p>
                              </Tooltip>
                            }
                          >
                            <span className="d-flex align-items-center">
                              <Button
                                className="my-2 ml-2"
                                onClick={() => this.props.startCustomerPortalSession()}
                              >
                                Billing Dashboard
                              </Button>
                            </span>
                          </OverlayTrigger>
                        </Row>
                        <Row className="w-75 mx-auto">
                          <Col className="d-flex justify-content-end pr-2">
                            {this.props.subscription.plan && (
                              <LoadingWrapper loadingKey="cancel-plan" smallBlock>
                                <Col className="px-0 d-flex flex-column flex-lg-row justify-content-end align-items-center">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        <span>Cancel unsaved changes</span>
                                      </Tooltip>
                                    }
                                  >
                                    <Link
                                      className="btn btn-danger m-2"
                                      variant="danger"
                                      to="/my-feeds"
                                    >
                                      Cancel
                                    </Link>
                                  </OverlayTrigger>

                                  <div>
                                    <SavedCheck savedKey="profile" />
                                    <Button form="updateProfileForm" type="submit" className="my-2">
                                      Save Profile
                                    </Button>
                                  </div>
                                </Col>
                              </LoadingWrapper>
                            )}
                          </Col>
                        </Row>
                      </>
                    ) : (
                      <div className="billing-background">
                        <LoadingWrapper loadingKey="get-subscription">
                          <Container>
                            <Row className="text my-4 justify-content-center flex-column text-center">
                              <div>You are on a lifetime plan.</div>
                              <div>This does not require billing information.</div>
                              <div>Please contact us if you would like help with your plan.</div>
                            </Row>
                          </Container>
                        </LoadingWrapper>
                      </div>
                    )}
                  </Col>
                </Row>
              </Container>
            </LoadingWrapper>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.basic.localUser,
    promoCodeValid: state.basic.promoCodeValid,
    subscription: state.basic.subscription,
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateProfile: ({
    name,
    email,
    password,
    replyTo,
    business,
    copyright,
    affiliateLink,
    affiliateLinkOptions,
    silent,
  }) =>
    dispatch({
      type: "UPDATE_PROFILE",
      name,
      email,
      password,
      replyTo,
      business,
      copyright,
      affiliateLink,
      affiliateLinkOptions,
      silent,
    }),
  checkPromoCode: (promoCode) => dispatch({ type: "CHECK_PROMO_CODE", promoCode }),
  getSubscription: (invoice) => dispatch({ type: "GET_SUBSCRIPTION", invoice }),
  cancelPlan: () => dispatch({ type: "CANCEL_PLAN" }),
  getInvoices: () => dispatch({ type: "GET_INVOICES" }),
  loadAffiliateCodeFromFirstPromoter: () =>
    dispatch({ type: "LOAD_AFFILIATE_CODE_FROM_FIRST_PROMOTER" }),
  startCustomerPortalSession: () => dispatch({ type: "START_CUSTOMER_PORTAL_SESSION" }),
  buyAlacarteRemasters: ({ callback }) => dispatch({ type: "BUY_ALACARTE_REMASTERS", callback }),
});

Account.propTypes = {
  buyAlacarteRemasters: PropTypes.func.isRequired,
  cancelPlan: PropTypes.func.isRequired,
  checkPromoCode: PropTypes.func.isRequired,
  getSubscription: PropTypes.func.isRequired,
  getInvoices: PropTypes.func.isRequired,
  loadAffiliateCodeFromFirstPromoter: PropTypes.func.isRequired,
  location: PropTypes.object,
  startCustomerPortalSession: PropTypes.func.isRequired,
  subscription: PropTypes.object,
  promoCodeValid: PropTypes.bool,
  updateProfile: PropTypes.func.isRequired,
  user: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(Account);
